const typeTagNames = {
    // Primary Types
    "general-emergent": "Emergent",
    "cancelled": "Cancelled/No Pt",
    "refusal": "Refusal", 
    "non-acute": "Non-Acute/Other",
    "non-emergent": "Non-Emergent",
    "unknown": "Unknown",
    "interfacility-transfer": "IFT",

    // Secondary Types
    "stroke": "Stroke",
    "arrest": "Arrest", 
    "stemi": "STEMI",
    "respiratory": "Resp",
    "seizure": "Seizure",
    "syncope": "Syncope",
    "hypoglycemia": "LBG",
    "asthma": "Asthma",
    "anaphylaxis": "AR",
    "abdominal-pain": "ABD",
    "auto-implant-cardiac-defib": "AICD",
    "adrenal-crisis": "Adrenal",
    "altered-mental-status": "AMS",
    "anxiety-hyperventilation": "Anxiety",
    "behavioral-psychiatric": "Psych",
    "envenomation": "Bite",
    "bradycardia": "Brady",
    "burns": "Burn",
    "carbon-monoxide": "CO",
    "cyanide": "Cyanide",
    "angina-pectoris": "Chest Pain",
    "congestive-heart-failure": "CHF",
    "left-vent-assist-device": "LVAD",
    "tachycardia": "Tachy",
    "crush-injury": "Crush",
    "dialysis": "Dialysis",
    "palliative-care": "EoL Care",
    "electrocution": "Electrocution",
    "drowning-water": "Drowning",
    "hypothermia": "Cold",
    "hyperthermia": "Heat",
    "alcohol-withdrawl": "Alc",
    "epistaxis": "Epistaxis",
    "fever-infection": "Fever",
    "migraine": "Migraine",
    "hyperactive-delirium": "Hyper Delirium",
    "eye-injury": "Eye Injury",
    "hypotension": "Hypotension",
    "hypertension": "Hypertension",
    "nausea-vomiting": "Nausea",
    "obstetrics": "Obs",
    "overdose-poisoning": "Overdose",
    "pain-management": "Pain",
    "hyperglycemia": "HBG",
    "sepsis": "Sepsis",
    "general-shock": "General Shock",
    "barb-removal": "Barb Removal",
    "infectious-disease": "Infectious Disease",
    "amputation-bleeding": "Amputation/Bleeding",

    // Tertiary Types
    "airway": "Airway",
    "narcotics": "Narcs",
    "pediatrics": "Ped",
    "high-risk-refusal": "HRR",
    "trauma": "Trauma",
    "tbi": "TBI",
    "patient-death": "Pt Death",

    // Auxiliary Types
    "ground-transport": "Ground",

    // Other
    "all": "All"
};

const primaryTypeTagNames = [
    "general-emergent",
    "cancelled",
    "refusal",
    "non-acute",
    "non-emergent",
    "unknown",
    "interfacility-transfer"
];

const secondaryTypeTagNames = [
    "stroke",
    "arrest",
    "stemi",
    "respiratory",
    "seizure",
    "syncope",
    "hypoglycemia",
    "asthma",
    "anaphylaxis",
    "abdominal-pain",
    "auto-implant-cardiac-defib",
    "adrenal-crisis",
    "altered-mental-status",
    "anxiety-hyperventilation",
    "behavioral-psychiatric",
    "envenomation",
    "bradycardia",
    "burns",
    "carbon-monoxide",
    "cyanide",
    "angina-pectoris",
    "congestive-heart-failure",
    "left-vent-assist-device",
    "tachycardia",
    "crush-injury",
    "dialysis",
    "palliative-care",
    "electrocution",
    "drowning-water",
    "hypothermia",
    "hyperthermia",
    "alcohol-withdrawl",
    "epistaxis",
    "fever-infection",
    "migraine",
    "hyperactive-delirium",
    "eye-injury",
    "hypotension",
    "hypertension",
    "nausea-vomiting",
    "obstetrics",
    "overdose-poisoning",
    "pain-management",
    "hyperglycemia",
    "sepsis",
    "general-shock",
    "barb-removal",
    "infectious-disease",
    "amputation-bleeding"
];

const tertiaryTypeTagNames = [
    "airway",
    "narcotics",
    "pediatrics",
    "high-risk-refusal",
    "trauma",
    "tbi",
    "patient-death"
];

const auxiliaryTypeTagNames = [
    "ground-transport"
];

const otherTagNames = [
    "all"
];

const attributeTagNames = {
    "check": "Check",
    "measure": "Measure",
    "quant-measure": "Quantitative Measure",
    "narrative-suggestion": "Narrative Suggestion",
    "medication-suggestion": "Medication Suggestion",
    "vitals-suggestion": "Vitals Suggestion",
    "[WARNING]": "Schematron: Warning",
    "[ERROR]": "Schematron: Error",
    "[FATAL]": "Schematron: Fatal"
};

export { typeTagNames, attributeTagNames, primaryTypeTagNames, secondaryTypeTagNames, tertiaryTypeTagNames, auxiliaryTypeTagNames, otherTagNames }; 